/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import TicketStub from '../icons/TicketStub';
import Button from './Button';

import styles from '../../../styles/buttons/ticket.module.scss';

const propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
};

const defaultProps = {
    className: null,
    color: 'currentColor',
    children: null,
    onClick: null,
};

const TicketButton = ({ className, color, children, onClick, ...props }) => (
    <Button
        onClick={onClick}
        className={classNames([styles.container, { [className]: className !== null }])}
        {...props}
    >
        <div className={styles.left}>
            <TicketStub color={color} className={styles.icon} />
        </div>
        <div className={styles.content}>{children}</div>
    </Button>
);

TicketButton.propTypes = propTypes;
TicketButton.defaultProps = defaultProps;

export default TicketButton;
